import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { WorkspaceDeviceTable } from '@/components/workspace';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceDevicesSubPage = (props: Props) => {
  return <WorkspaceDeviceTable workspace={props.workspace} />;
};
